const Icon = () => {
  return (
    <img src={`${AZURE_BASE_URL}/icon_facebook.webp`} alt="Facebook icon" />
  )
}

const FacebookIcon = () => {
  return (
    <div className="facebook">
      <div className="facebook__icon">
        <Icon />
      </div>
      <p className="facebook__text">
        Continuar con Facebook
      </p>
    </div>
  )
}

export default FacebookIcon